import React from 'react';
import { commonWrapperOptions } from '@components/modal/CommonWrapper';
import TicketInfoV2 from '@components/modal/ticket/TicketInfoV2';
import useModal from '@lib/hooks/useModal';
import styled from 'styled-components';

interface TicketIdCellProps {
  ticketId: number;
  ticketNumber?: string | number;
  account?: AccountLevel;
  refetch?: () => void;
}

const StyledTicketId = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: inherit;
  font-family: inherit;
  border-radius: 6px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.neutralGray[100]};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
    border-radius: 6px;
  }
`;

/**
 * 테이블 내에서 이용권 권번을 표시하고 클릭 시 상세정보 모달을 여는 컴포넌트
 *
 * @example
 * // 테이블 컬럼 정의에서 사용
 * {
 *   Header: '이용권 권번',
 *   accessor: 'ticketId',
 *   Cell: ({ value, row }) => (
 *     <TicketIdCell
 *       ticketId={value}
 *       ticketNumber={row.original.ticketNumber}
 *       account="admin"
 *       refetch={refetch}
 *     />
 *   )
 * }
 */
const TicketIdCell: React.FC<TicketIdCellProps> = ({
  ticketId,
  ticketNumber,
  account = 'merchant',
  refetch,
}) => {
  const { openModal } = useModal();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    openModal(
      () => <TicketInfoV2 ticketId={ticketId} account={account} refetch={refetch} />,
      commonWrapperOptions,
    );
  };

  return <StyledTicketId onClick={handleClick}>{ticketNumber || ticketId}</StyledTicketId>;
};

export default TicketIdCell;
